import api from '../';

class cosmoTourGameApi {
    //GET: items
    static getGameItems(params) {
        return api.axios.get('/cosmo-tour/items', { params }).then(response => response.data);
    }
}

export default cosmoTourGameApi;
